import React from 'react';
import { RendererProps } from '../types';

export function HiddenInputRenderer({ element }: RendererProps) {
	const { type, ...rest } = element;

	return <input type="hidden" {...rest} />;
}
